import { UserRoles } from '../enums';

export const RolesValueSelect: SelectProps[] = [
  { label: 'Administrador', value: UserRoles.ADMIN },
  { label: 'Espectador', value: UserRoles.SPECTATOR },
  { label: 'RH Central', value: UserRoles.RH_CENTRAL },
  { label: 'RH Loja', value: UserRoles.RH_LOJA },
  { label: 'Auditor', value: UserRoles.AUDITOR },
];
